


import Vue from 'vue';
import i18n from "@/i18n/i18n.config";

export default Vue.extend({
    created(): void {
        if (navigator.language === 'pl') {
            i18n.locale = 'pl';
        } else {
            i18n.locale = 'en';
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    },
    metaInfo: {
        meta: [
            {name: 'robots', content: 'noindex'}
        ]
    }
});
